import { AppBar, Button, Menu, MenuItem, Toolbar } from '@mui/material';
import firebase from 'firebase/compat/app';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { currentAuthAtom } from '../jotai/atoms';
import { Blank } from './Blank';
import { LoadingPage } from './LoadingPage';

const styles = {
  header: {
    backgroundColor: '#edf0f3'
  },
  logo: {
    height: 32
  },
  displayName: {
    textTransform: 'none',
    color: 'text.primary'
  }
} as const;

export function Header({}) {
  return (
    <AppBar position="relative" sx={styles.header}>
      <Toolbar variant="dense">
        <Link to="/">
          <img
            src={require('../resources/hackforplay-admin.png')}
            style={styles.logo}
            alt=""
          />
        </Link>
        <Blank grow={1} />
        <UserMenu />
      </Toolbar>
    </AppBar>
  );
}

function UserMenu() {
  const userInfo = useAtomValue(currentAuthAtom);

  const signOut = React.useCallback(() => {
    firebase.auth().signOut();
  }, []);

  // メニュー
  const [menuOpen, setMenuOpen] = React.useState(false);
  const anchorEl = React.useRef<HTMLButtonElement>(null);

  return (
    <React.Suspense fallback={<LoadingPage />}>
      <Button
        size="small"
        onClick={() => setMenuOpen(true)}
        ref={anchorEl}
        sx={styles.displayName}
      >
        {userInfo?.displayName || ''}
        {` (Google アカウント)`}
      </Button>
      <Menu
        open={menuOpen}
        anchorEl={anchorEl.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        onClose={() => setMenuOpen(false)}
      >
        <MenuItem disabled={!userInfo} onClick={signOut}>
          ログアウト
        </MenuItem>
      </Menu>
    </React.Suspense>
  );
}
